"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpsertOrder = void 0;
class UpsertOrder {
    constructor(orderRepository) {
        this.orderRepository = orderRepository;
    }
    execute(request) {
        return this.orderRepository.upsertOrder(request);
    }
}
exports.UpsertOrder = UpsertOrder;
